(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else {
    root.ThornvellaTransfer = factory();
    root.ThornvellaTransfer.capture();
  }
})(typeof window === 'undefined' ? this : window, function () {
  'use strict';
  const key = 'thornvella-country-basket-v1';
  const hosts = new Set(['thornvella.com', 'www.thornvella.com', 'thornvella.com.au', 'www.thornvella.com.au', '918fbu-y0.myshopify.com']);
  const issue = () => Object.assign(new Error('transfer'), { code: 'transfer' });
  const origin = value => {
    try { const url = new URL(value); return url.protocol === 'https:' && hosts.has(url.hostname) ? url.origin : null; }
    catch (_) { return null; }
  };
  const properties = value => {
    if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).length > 64) throw issue();
    if (Object.entries(value).some(([k, v]) => k.length > 256 || (v !== null && !['string', 'number', 'boolean'].includes(typeof v)) || String(v).length > 10000)) throw issue();
    return value;
  };
  const validate = (p, now = Date.now()) => {
    if (!p || p.v !== 1 || !/^[A-Z]{2}$/.test(p.c) || typeof p.n !== 'string' || p.n.length > 80 || !origin(p.s) || p.s !== origin(p.s) || !/^\/[a-zA-Z0-9/_-]*$/.test(p.r) || p.r.length > 100 || !Number.isFinite(p.t) || p.t > now + 60000 || now - p.t > 3600000 || !Array.isArray(p.l) || p.l.length > 100) throw issue();
    for (const line of p.l) {
      if (!Array.isArray(line) || !/^[a-z0-9][a-z0-9-]*$/.test(line[0]) || !/^\d{1,16}$/.test(String(line[1])) || !Number.isSafeInteger(Number(line[1])) || !Number.isSafeInteger(line[2]) || line[2] < 1 || line[2] > 9999 || !Array.isArray(line[3]) || line[3].length > 3 || line[3].some(o => !Array.isArray(o) || o.length !== 2 || o.some(v => typeof v !== 'string' || v.length > 256)) || (line[5] !== null && !/^\d+$/.test(String(line[5])))) throw issue();
      properties(line[4]);
    }
    if (p.note !== null && (typeof p.note !== 'string' || p.note.length > 10000)) throw issue();
    properties(p.attributes);
    if (!Array.isArray(p.discounts) || p.discounts.length > 10 || p.discounts.some(s => typeof s !== 'string' || s.length > 256)) throw issue();
    return p;
  };
  const bytesToBase64 = bytes => btoa(Array.from(bytes, b => String.fromCharCode(b)).join('')).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, '');
  const base64ToBytes = value => Uint8Array.from(atob(value.replaceAll('-', '+').replaceAll('_', '/')), c => c.charCodeAt(0));
  async function pack(cart, country, source, root) {
    const payload = validate({ v: 1, t: Date.now(), n: crypto.randomUUID(), c: country, s: source, r: root,
      l: cart.items.map(i => [i.handle, i.variant_id || i.id, i.quantity, (i.options_with_values || []).map(o => [o.name, o.value]), Object.fromEntries(Object.entries(i.properties || {}).filter(([k]) => k !== '_thornvella_regional_swap')), i.selling_plan_allocation?.selling_plan?.id || i.selling_plan || null]),
      note: cart.note || null, attributes: cart.attributes || {}, discounts: (cart.discount_codes || []).map(d => typeof d === 'string' ? d : d.code).filter(Boolean)
    });
    const text = JSON.stringify(payload);
    if (text.length > 100000) throw issue();
    let bytes = new TextEncoder().encode(text), prefix = 'j.';
    if (typeof CompressionStream === 'function') {
      bytes = new Uint8Array(await new Response(new Blob([bytes]).stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer());
      prefix = 'g.';
    }
    const packet = prefix + bytesToBase64(bytes);
    if (packet.length > 24000) throw issue();
    return packet;
  }
  async function unpack(packet) {
    if (typeof packet !== 'string' || packet.length > 24000 || !/^[gj]\.[A-Za-z0-9_-]+$/.test(packet)) throw issue();
    try {
      let bytes = base64ToBytes(packet.slice(2));
      if (packet.startsWith('g.')) {
        const reader = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip')).getReader();
        const chunks = []; let length = 0;
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          length += value.length;
          if (length > 130000) { await reader.cancel(); throw issue(); }
          chunks.push(value);
        }
        bytes = new Uint8Array(length); let offset = 0;
        for (const chunk of chunks) { bytes.set(chunk, offset); offset += chunk.length; }
      }
      if (bytes.length > 130000) throw issue();
      return validate(JSON.parse(new TextDecoder().decode(bytes)));
    } catch (_) { throw issue(); }
  }
  function capture() {
    try {
      const url = new URL(location.href), parameters = new URLSearchParams(url.hash.slice(1)), packet = url.searchParams.get('tv_cart') || parameters.get('tv_cart');
      if (!packet) return;
      const referrer = origin(document.referrer);
      if (referrer && packet.length <= 24000) sessionStorage.setItem(key, JSON.stringify({ packet, referrer, failed: false }));
      parameters.delete('tv_cart');
      url.searchParams.delete('tv_cart');
      history.replaceState(null, '', url.pathname + url.search + (parameters.size ? '#' + parameters.toString() : ''));
    } catch (_) {}
  }
  async function pending() {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (!saved || saved.failed) return null;
    if (!origin(saved.referrer)) throw issue();
    return unpack(saved.packet);
  }
  function suspended(failed) {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved) { saved.failed = failed; sessionStorage.setItem(key, JSON.stringify(saved)); }
  }
  const items = p => p.l.map(l => ({ handle: l[0], variant_id: l[1], quantity: l[2], options_with_values: l[3].map(o => ({ name: o[0], value: o[1] })), properties: l[4], selling_plan: l[5] }));
  return { pack, unpack, validate, capture, pending, suspend: () => suspended(true), resume: () => suspended(false), clear: () => sessionStorage.removeItem(key), items };
});

